var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.01 290.01",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#2969B3;}\r\n\t.st2{fill:#222653;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n\t.st4{fill:#CDEAE8;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8.1379,8.1379;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.31,113.47C198.31,113.47,198.31,113.47,198.31,113.47c-3.95,1.69-11.3,3.68-20.84,5.46 C188.11,116.96,195.97,114.84,198.31,113.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.57,110.97c0.04,0.17-0.01,0.35-0.13,0.54c0.38-0.27,0.63-0.47,0.79-0.62c-0.08-0.29-0.12-0.45-0.12-0.45 s0.76-0.16,0.12,0.45c0.53,1.96,2.68,10.09,4.58,18.58c2.18,9.75,6.31,34.17,7.91,47.47c1.32,10.96,3.26,28.45,4.42,45.94 c6.61-12.62,15.3-29.5,15.3-29.5s0.76-38.06,0.76-49.68c0-11.62,2.45-52.28,5.81-57.48c-1.8-6.75-16.52-59.07-24.17-86.2h-7.08 c-2.64,29.46-9.72,99.44-9.72,99.44S200.34,105.46,201.57,110.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.89,240.22c0.46,19.49,0.69,38.06,0.69,38.06l-0.64,11.73h13.17c-2.45-13.7-6.46-35.98-7.26-41.08 C131.71,241.59,126.43,220.73,126.89,240.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.7,119.08c-0.36,0.07-0.72,0.13-1.08,0.19C175.98,119.21,176.34,119.14,176.7,119.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.46,0c4.46,17.48,17.82,65.72,17.82,65.72s6.11,17.12,0,43.72c-6.11,26.6-20.48,82.55-20.48,82.55 l-11.31,55.03l-25.39,26.41c0.22,5.43,0.25,10.92,0.1,16.58h64.81V0H264.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.06,162.25c5.96-25.91,2.52-14.9,9.63-47.12c0,0,0.16-82.58,0.08-115.13h-1.38 c-2.36,24.29-6.35,71.64-8.1,84.37c-2.14,15.59-5.5,59.01-9.48,75.52s-7.64,35.77-8.25,47.08c-0.61,11.31-0.61,14.68,4.28,20.79 c3.52,7.04,6.73,19.57,2.75,21.1c-3.97,1.53-6.11-7.18-9.02-8.87c-2.9-1.68-4.28-1.38-3.82,6.27s-1.7,17.73-0.09,19.57 s13.54,14.68,15.07,18.04c1.53,3.36-1.38,1.68-6.27-1.22c-4.89-2.9-14.83-6.88-18.19-14.83c-3.36-7.95-7.95-14.68-8.25-24.92 c-0.31-10.24,1.53-80.56,3.06-94.93c1.53-14.37,1.22-46.17,2.75-60.23c1.53-14.06,3.67-49.22,4.28-62.98 C22.4,18.06,22.41,8.84,22.34,0H0v290.01h50.16C49.46,265.69,47.57,186.1,53.06,162.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.55,248.29c0.45,2.79,0.85,5.56,1.19,8.32c1.29-2.42,2.24-4.29,2.59-5.16 C227.73,247.95,225.92,244.2,222.55,248.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.31,119.5c-0.5,0.09-1,0.17-1.51,0.26C173.31,119.67,173.82,119.59,174.31,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.66,123.77c0.02,0,0.04,0,0.07,0c18.03,0.86,38.79-1.29,54.82-3.98 C157.37,122.32,137.78,124.19,117.66,123.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.1,110.43c0,0,0.04,0.16,0.12,0.45C202.87,110.28,202.1,110.43,202.1,110.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.1,273.43l-12.37,12.87c0,0-6.27,1.22-3.67-3.36c2.01-3.54,10.31-18.12,14.69-26.33 c-0.34-2.76-0.73-5.53-1.19-8.32c-0.31,0.38-0.63,0.81-0.96,1.32c-3.97,6.11-10.7,18.8-11.01,19.41s-2.14,2.29-2.14,2.29 s-2.9,0.61-2.29-2.29s2.9-27.82,6.11-33.32c1.04-1.78,3.72-6.83,6.87-12.84c-1.16-17.49-3.1-34.98-4.42-45.94 c-1.61-13.3-5.73-37.72-7.91-47.47c-1.9-8.48-4.05-16.61-4.58-18.58c-0.16,0.16-0.41,0.35-0.79,0.62 c-0.37,0.57-1.44,1.24-3.12,1.96c0,0,0,0-0.01,0c-2.34,1.37-10.2,3.49-20.84,5.46c-0.25,0.05-0.51,0.1-0.77,0.14 c-0.36,0.07-0.72,0.13-1.08,0.19c-0.43,0.08-0.86,0.15-1.3,0.23c-0.5,0.09-1,0.17-1.51,0.26c-0.08,0.01-0.17,0.03-0.25,0.04 c-16.03,2.69-36.79,4.83-54.82,3.98c-0.02,0-0.04,0-0.07,0c-18.93-0.39-38.32-2.81-54.97-8.64c-7.11,32.22-3.67,21.21-9.63,47.12 c-5.49,23.85-3.59,103.43-2.9,127.76h76.78l0.64-11.73c0,0-0.23-18.57-0.69-38.06c-0.46-19.49,4.82,1.38,5.96,8.71 c0.8,5.1,4.81,27.38,7.26,41.08h85.09C225.35,284.35,225.32,278.86,225.1,273.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.1,24.75c-0.61,13.76-2.75,48.92-4.28,62.98c-1.53,14.06-1.22,45.86-2.75,60.23 c-1.53,14.37-3.36,84.69-3.06,94.93c0.31,10.24,4.89,16.97,8.25,24.92c3.36,7.95,13.3,11.92,18.19,14.83 c4.89,2.9,7.8,4.59,6.27,1.22c-1.53-3.36-13.45-16.2-15.07-18.04s0.55-11.92,0.09-19.57s0.92-7.95,3.82-6.27 c2.9,1.68,5.04,10.4,9.02,8.87c3.97-1.53,0.77-14.06-2.75-21.1c-4.89-6.11-4.89-9.48-4.28-20.79c0.61-11.31,4.28-30.57,8.25-47.08 s7.34-59.92,9.48-75.52c1.75-12.73,5.73-60.08,8.1-84.37H22.34C22.41,8.84,22.4,18.06,22.1,24.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.69,115.13c16.65,5.83,36.05,8.25,54.97,8.64c20.12,0.42,39.71-1.45,54.89-3.97 c0.08-0.01,0.17-0.03,0.25-0.04c0.51-0.09,1.01-0.17,1.51-0.26c0.44-0.08,0.87-0.15,1.3-0.23c0.36-0.06,0.73-0.13,1.08-0.19 c0.26-0.05,0.51-0.09,0.77-0.14c9.55-1.78,16.89-3.77,20.85-5.47c1.68-0.72,2.75-1.39,3.12-1.96c0.12-0.19,0.17-0.37,0.13-0.54 c-1.22-5.5-1.53-11.53-1.53-11.53s7.07-69.98,9.72-99.44H62.77C62.85,32.56,62.69,115.13,62.69,115.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235.2,143.68c0,11.62-0.76,49.68-0.76,49.68s-8.69,16.89-15.3,29.5c-3.15,6.02-5.83,11.06-6.87,12.84 c-3.21,5.5-5.5,30.42-6.11,33.32s2.29,2.29,2.29,2.29s1.83-1.68,2.14-2.29s7.03-13.3,11.01-19.41c0.33-0.51,0.65-0.95,0.96-1.32 c3.37-4.1,5.18-0.34,3.78,3.16c-0.35,0.87-1.3,2.74-2.59,5.16c-4.38,8.21-12.68,22.79-14.69,26.33c-2.6,4.59,3.67,3.36,3.67,3.36 l12.37-12.87l25.39-26.41l11.31-55.03c0,0,14.37-55.95,20.48-82.55c6.11-26.6,0-43.72,0-43.72S268.92,17.48,264.46,0h-47.62 c7.64,27.14,22.37,79.45,24.17,86.2C237.64,91.4,235.2,132.06,235.2,143.68z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.13,131.92c0,0,58.82,31.03,147.68-2.45"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage4);
export default __webpack_public_path__ + "static/media/image4.b406501476d2ff3c6ba9ed3f17fb7731.svg";
export { ForwardRef as ReactComponent };